import React from 'react';
import { Backdrop, Box, Typography } from '@mui/material';
import useLoaderSelector from '../store/Slice/Loader/LoaderSelector';

export default function CustomLoader() {
  const { isPageLoading } = useLoaderSelector() || {};

  return (
    <Backdrop
      sx={{ zIndex: 10000, display: 'flex', flexDirection: 'column' }}
      open={Boolean(isPageLoading?.loading)}
    >
      <Box
        sx={{
          position: 'relative',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: 100,
          height: 100
        }}
      >
        <svg style={{ position: 'absolute', width: '100%', height: '100%' }} viewBox="0 0 100 100">
          <circle cx="50" cy="50" r="45" fill="none" stroke="#e2e8f0" strokeWidth="3" />
        </svg>

        <svg
          style={{
            position: 'absolute',
            width: '100%',
            height: '100%',
            animation: 'kpros-spin 1.5s linear infinite'
          }}
          viewBox="0 0 100 100"
        >
          <circle
            cx="50"
            cy="50"
            r="45"
            fill="none"
            stroke="#3EC0C1"
            strokeWidth="4"
            strokeLinecap="round"
            strokeDasharray="283"
            strokeDashoffset="70"
          />
        </svg>

        <Box
          sx={{
            width: '50px',
            height: '50px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            animation: 'kpros-flip 2.5s infinite cubic-bezier(0.455, 0.03, 0.515, 0.955)'
          }}
        >
          <img
            src="/static/logos/kalolyticLogoIcon.svg"
            alt="Kalolytic Logo"
            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
          />
        </Box>
      </Box>

      <Typography
        sx={{
          mt: 2,
          fontFamily: "'Poppins', sans-serif",
          fontSize: '0.875rem',
          fontWeight: 600,
          letterSpacing: '1px',
          color: 'white',
          textTransform: 'uppercase',
          animation: 'kpros-pulseText 2s ease-in-out infinite',
          display: 'flex',
          alignItems: 'center',
          gap: 0.5
        }}
      >
        {isPageLoading?.loadingMessage || 'Processing'}
        <span style={{ display: 'inline-flex', width: '16px', textAlign: 'left' }}>
          <span style={{ animation: 'kpros-dot 1.5s infinite steps(1) 0s' }}>.</span>
          <span style={{ animation: 'kpros-dot 1.5s infinite steps(1) 0.5s' }}>.</span>
          <span style={{ animation: 'kpros-dot 1.5s infinite steps(1) 1s' }}>.</span>
        </span>
      </Typography>

      <style>
        {`
          @keyframes kpros-spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          @keyframes kpros-flip {
            0% { transform: perspective(400px) rotateY(0deg); }
            50% { transform: perspective(400px) rotateY(180deg); }
            100% { transform: perspective(400px) rotateY(360deg); }
          }
          @keyframes kpros-pulseText {
            0%, 100% { opacity: 0.8; }
            50% { opacity: 0.4; }
          }
          @keyframes kpros-dot {
            0%, 20% { opacity: 0; }
            40%, 100% { opacity: 1; }
          }
        `}
      </style>
    </Backdrop>
  );
}
